export const variablesData = {
  total: 1,
  limit: 50,
  skip: 0,
  data: {
    vars: [
      {
        id: 1,
        name: 'Current length',
        displayName: 'Length Name',
        value: '{Weight}/{Diagnosis}*{Diagnosis}',
        type: 'integer',
        unitType: 'length',
        createdAt: '2019-10-24T16:39:20.739Z',
        updatedAt: '2019-10-24T16:39:20.739Z',
        createdBy: null,
        updatedBy: null,
        usedIn: ['recommendation_condition'],
        unitOfMeasurementPossibilities: ['mcg', 'mg', 'g', 'kg', 'mt', 'oz', 'lb', 't'],
      },
    ],
  },
};
